import { jsx as _jsx } from "react/jsx-runtime";
import styles from './OrderBatching.module.scss';
export const getBatchColumns = (onDownload) => [
    {
        key: 'batch_timestamp',
        header: 'DATE & TIME',
        sortable: true,
        render: (batch) => batch.formatted_batch_date || batch.batch_timestamp,
    },
    {
        key: 'manufacturer',
        header: 'MANUFACTURER',
        sortable: true,
        render: (batch) => batch.manufacturer || 'All (combined)',
    },
    {
        key: 'number_of_orders',
        header: 'NUMBER OF ORDERS',
        sortable: true,
        render: (batch) => batch.number_of_orders.toString(),
    },
    {
        key: 'recipient_email',
        header: 'RECIPIENT EMAIL',
        sortable: true,
        render: (batch) => batch.recipient_email || 'N/A',
    },
    {
        key: 'filename',
        header: 'FILE NAME',
        sortable: true,
        render: (batch) => batch.download_filename || batch.filename || 'N/A',
    },
    {
        key: 'created_at',
        header: 'CREATED',
        sortable: true,
        render: (batch) => batch.created_at || 'N/A',
    },
    {
        key: 'download',
        header: 'DOWNLOAD',
        sortable: false,
        render: (batch) => (_jsx("button", { type: "button", className: styles.downloadButton, onClick: (event) => {
                event.stopPropagation();
                onDownload(batch);
            }, children: "Download" })),
    },
];
